export const step01 = {
    "id": 1,
    "businessDcom": "Abc",
    "businessName": "Abc (pvt) Ltd",
    "businessType": "Manufacturer",
    "brNumber": "sl5689745",
    "brnFilePath": "26449494",
    "tin": "72456892456",
    "tinFilePath": "646+4",
    "vatNumber": "12458796347",
    "vatFilePath": "649498949",
    "address": "Galle road, Colombo 02",
    "status": "PENDING",
    "createdDate": null,
    "modifiedDate": null,
    "modifiedBy": "Lahiru",
    "userId": {
        "id": 1,
        "fullName": null,
        "email": "amal@gmail.com",
        "contactNumber": "0775648792",
        "password": "amal123",
        "brNumber": "89499165999",
        "companyName": null
    },
    "cpUserCollection": [],
    "cpFactoryDetailsCollection": [],
    "cpContactPersonCollection": [
        {
            "id": 1,
            "createdDate": null,
            "lastModifiedDate": null,
            "fullName": "Kasun disanayaka",
            "designation": "stakeholder",
            "nicNo": "907852134v",
            "nicBackPath": "5698741236544",
            "nicFrontPath": "4569872555462",
            "email": "kasun@gmail.com",
            "digitalSignaturePath": "554963311233",
            "mobile": "0774569821",
            "fax": "0116587412",
            "status": "PENDING",
            "modifiedBy": "Lahiru",
            "telephone": "0418546235",
            "type": "contact"
        }
    ],
    "cpProductDetailsCollection": [
        {
            "id": 1,
            "createdDate": null,
            "lastModifiedDate": null,
            "hsCode": "09021013",
            "destination": "India",
            "productCategory": "Non-Wholly",
            "productDescription": "readymade garments",
            "tradeAgreement": "ISFTA",
            "draftCostStatementOrAffidavitFilePath": "4949889949849498",
            "productName": "denim jeans",
            "modifiedBy": "Lahiru",
            "status": "PENDING"
        }
    ],
    "cpManagementCollection": [
        {
            "id": 1,
            "createdDate": null,
            "lastModifiedDate": null,
            "fullName": "Lahiru Samaraweera",
            "designation": "Product manager",
            "nicNo": "854533197v",
            "nicBackPath": "5996519449647",
            "nicFrontPath": "26684255545555",
            "email": "lahiru@gmail.com",
            "mobile": "0715641239",
            "telephone": "0112569782",
            "status": "PENDING",
            "residenceAddress": "no 234,Galle road, Colombo 03",
            "digitalSignaturePath": "6987454555555544f",
            "modifiedBy": "kasun"
        }
    ]
}

export const tailMock = {
    "applicationTrailId":"",
    "applicationId":"",
    "applicationType":"",
    "approvalLevel":"",
    "officer":"",
    "applicationSubmittedDatetime":"",
    "approvalProcessStartDatetime":"",
    "approvalProcessEndDatetime":"",
    "applicationStatus":"",
    "remarks":""
}